import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=07ff3a0e&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ff3a0e')) {
      api.createRecord('07ff3a0e', component.options)
    } else {
      api.reload('07ff3a0e', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=07ff3a0e&", function () {
      api.rerender('07ff3a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iJ0FwAMOH3Ye/JS/priceformat.vue"
export default component.exports